import { iconContainerStyles } from "../../styles/commonStyles";

export const fieldNoteDialogConfig = {
  slotProps: {
    paper: {
      sx: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        p: 2,
        heigth: "605px",
        overflow: "hidden",
        flexDirection: "column",
      },
    },
  },
  divStyle: {
    flex: 1,
    width: "100%",
    overflowY: "auto",
    marginTop: 8,
  },
};

export const noteDetailDialogConfig = {
  paper: {
    width: "551px",
    height: "605px",
    padding: 2,
  },
  iconBox: {
    ...iconContainerStyles,
    width: "40px",
    height: "40px",
  },
  contentBox: {
    width: "100%",
    height: "100%",
    paddingX: "55px",
    paddingY: "45px",
  },
  mapBox: {
    mt: 2,
    width: "432px",
    height: "266px",
  },
};
